exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer {\n  border-top: solid #00b894;\n  border-width: 20px;\n  margin-top: 40px;\n}\n\np {\n  margin-bottom: 10px;\n}\n\na {\n  font-size: 15px;\n  color: #fff;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/trevor/src/src-westoaks3/west-oaks/src/app/footer/footer.component.css
// module id = ../../../../../src/app/footer/footer.component.css
// module chunks = main